import { createCookieManager } from "../../../nodemodules/@jwplayer/fe-common/module/cookies/index.js";
import { getDomain, getEnvVariable } from "../util/environment.js";

//#region ../base/auth/cookies.ts
const cookieManager = createCookieManager({
	Path: "/",
	Domain: getDomain(),
	Secure: getEnvVariable("TEST") ? void 0 : true,
	SameSite: "strict"
});

//#endregion
export { cookieManager };
//# sourceMappingURL=cookies.js.map